import { render, staticRenderFns } from "./SearchAreaButton.vue?vue&type=template&id=50a726f6&scoped=true&"
import script from "./SearchAreaButton.vue?vue&type=script&lang=js&"
export * from "./SearchAreaButton.vue?vue&type=script&lang=js&"
import style0 from "./SearchAreaButton.vue?vue&type=style&index=0&id=50a726f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a726f6",
  null
  
)

export default component.exports